export default {
    //滚动到指定位置
    scrollView(object){
        for(let i in object){
            let dom = this.$refs[i]
            console.log('dom: ',dom)
            dom.$el.scrollIntoView({
                block: 'center',
                behavior: 'smooth'
            })
            break
        }
    },
	// vid 选择的id , arr  需要匹配的数组
	getSelectObj(vId, arr) {
		let obj = {};
		obj = arr.find((item) => { //this.ruleForm
			return item.id === vId; //筛选出匹配数据
		});
		return obj
    },
    

	// 格式化
	format(val) {
		if (!val) {
			return ''
		}
		let now = new Date(val),
			y = now.getFullYear(),
			m = now.getMonth() + 1,
			d = now.getDate();
		return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    },
    formatMonth(val) {
		if (!val) {
			return ''
		}
        let now = new Date(val),
            y = now.getFullYear(),
            m = now.getMonth() + 1;
		return y + "-" + (m < 10 ? "0" + m : m);
	},
	kilo(num) {
		var str = num + '';
		return str.split("").reverse().reduce((prev, next, index) => {
			return ((index % 3) ? next : (next + ',')) + prev;
		})
	},
	// 格式化
	formatDateTime(val) {
		if (!val) {
			return ''
		}
		var now = new Date(val),
			y = now.getFullYear(),
			m = now.getMonth() + 1,
			d = now.getDate();
		return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
	},
    /**
     * @param {Function} func
     * @param {number} wait
     * @param {boolean} immediate
     * @return {*}
     */
    /**
 - 防抖函数，返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
 -  * @param  {function} func        回调函数
 - @param  {number}   wait        表示时间窗口的间隔
 - @param  {boolean}  immediate   设置为ture时，是否立即调用函数
 - @return {function}             返回客户调用函数
 */
  debounce (func, wait = 50, immediate = true) {
    let timer, context, args
    console.log('..........')
    // 延迟执行函数
    const later = () => setTimeout(() => {
      // 延迟函数执行完毕，清空缓存的定时器序号
      timer = null
      // 延迟执行的情况下，函数会在延迟函数中执行
      // 使用到之前缓存的参数和上下文
      if (!immediate) {
        func.apply(context, args)
        context = args = null
      }
    }, wait)
  
    // 这里返回的函数是每次实际调用的函数
    return function(...params) {
      // 如果没有创建延迟执行函数（later），就创建一个
      if (!timer) {
        timer = later()
        // 如果是立即执行，调用函数
        // 否则缓存参数和调用上下文
        if (immediate) {
          func.apply(this, params)
        } else {
          context = this
          args = params
        }
      // 如果已有延迟执行函数（later），调用的时候清除原来的并重新设定一个
      // 这样做延迟函数会重新计时
      } else {
        clearTimeout(timer)
        timer = later()
      }
    }
  }
}